// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MjyT","question":"styles_question__2cCgm","description":"styles_description__2xEk6"};